/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Safe.vue?vue&type=template&id=1358ff54&scoped=true&"
import script from "./Safe.vue?vue&type=script&lang=js&"
export * from "./Safe.vue?vue&type=script&lang=js&"
import style0 from "./Safe.vue?vue&type=style&index=0&id=1358ff54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1358ff54",
  null
  
)

export default component.exports